/**
 * 直播记录 API（118 方案 P4：观看端由 Java 老后端迁移到 ai_mall_py）。
 *
 * 变更说明：
 * - 原走 Global.BASE_URL(8090) + /api/live_record/current，现走 aiApiUtil
 *   通道（AI_BASE_URL 别名），路径不变
 * - py 响应为 GlxVo 信封，glxGet 统一解包取 data；data 内字段与 Java
 *   camelCase 逐字一致（{liveRecord, liveGoodsList}），
 *   消费方（useFetchLiveRecord）零改动
 */
import {glxGet} from './aiApiUtil';

export async function currentLiveRecord({liveId}) {
    return glxGet('/live_record/current', {
        params: {
            liveId
        }
    })
}
